import { render, staticRenderFns } from "./LaudoHistoricoAgricolaModal.vue?vue&type=template&id=4e1bb68c&scoped=true&lang=pug"
import script from "./LaudoHistoricoAgricolaModal.vue?vue&type=script&lang=js"
export * from "./LaudoHistoricoAgricolaModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoHistoricoAgricolaModal.vue?vue&type=style&index=0&id=4e1bb68c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1bb68c",
  null
  
)

export default component.exports